/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const VuesaxBrokenCode = ({ className }) => {
  return (
    <svg
      className={`vuesax-broken-code ${className}`}
      fill="none"
      height="57"
      viewBox="0 0 57 57"
      width="57"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M21.375 30.875C19.8075 31.6587 18.5013 32.8225 17.5275 34.2713C16.9813 35.1025 16.9813 36.1475 17.5275 36.9787C18.5013 38.4275 19.8075 39.5912 21.375 40.375"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        className="path"
        d="M36.1238 30.875C37.6913 31.6587 38.9975 32.8225 39.9713 34.2713C40.5175 35.1025 40.5175 36.1475 39.9713 36.9787C38.9975 38.4275 37.6913 39.5912 36.1238 40.375"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        className="path"
        d="M4.75 30.875V35.625C4.75 47.5 9.5 52.25 21.375 52.25H35.625C47.5 52.25 52.25 47.5 52.25 35.625V21.375C52.25 9.5 47.5 4.75 35.625 4.75H21.375C9.5 4.75 4.75 9.5 4.75 21.375"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        className="path"
        d="M5.29625 19.0237L50.9437 19"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
    </svg>
  );
};
